import { render, staticRenderFns } from "./BezahlenBestaetigt.vue?vue&type=template&id=090c64ce"
import script from "./BezahlenBestaetigt.vue?vue&type=script&lang=ts"
export * from "./BezahlenBestaetigt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports